import React, { useState, useEffect, useCallback, createRef } from 'react';
import qs from 'qs';
import clsx from 'clsx';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import LinearProgress from '@material-ui/core/LinearProgress';
import Snackbar from '@material-ui/core/Snackbar';

import { paramConverter } from 'modules/common';
import {
  fetchHeader,
  under2camel,
  fileDownload,
  nullConversion,
} from 'lib/commonLib';
import { tableHeaders, setCustom } from 'lib/api/common';

import DivisionWrap from 'components/atoms/DivisionWrap';
import SetUpList from 'components/molecules/SetUpList';
import EnhancedTableWrap from 'components/molecules/MbTable/EnhancedTableWrap';
import EnhancedTableHead from 'components/molecules/MbTable/EnhancedTableHead';
import EnhancedTableBody from 'components/molecules/MbTable/EnhancedTableBody';
import SnackbarContentWrapper from 'components/molecules/Snackbar/SnackbarContentWrapper';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  fullscreen: {
    position: 'fixed',
    zIndex: theme.zIndex.fullScreen,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    padding: 20,
    boxSizing: 'border-box',
    backgroundColor: '#fff',
  },
  tableWrap: {
    position: 'relative',
  },
  tableCustomScrollBar: {
    '& > div:first-child': {
      position: 'relative !important',
    },
    '&.isModalHeight > div:first-child': {
      maxHeight: 450,
    },
    '& > div:not(first-child)': {
      zIndex: theme.zIndex.table.scrollbar,
    },
  },
  tableContentsWrap: {
    display: 'flex',
    maxHeight: '730px',
    '& > div': {
      flex: '1 0 auto',
    },
  },
  tableSection: {
    borderCollapse: 'separate',
    '& P': {
      margin: 0,
    },
  },
  loadingBarWrap: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'none',
    '&.loading': {
      display: 'block',
    },
  },
  loadingBar: {
    zIndex: theme.zIndex.tableLoading,
    position: 'absolute',
    bottom: '9px',
    width: '98%',
  },
  messageSize: {
    fontSize: 18,
  },
}));

let fullTableHeight;
const useReference = () => {
  const [getScrollRef] = useState(() => createRef());

  return getScrollRef;
};

let hoverCount = 0;
let pathName = window.location.pathname;
let firstFetching = false;
const EnhancedTableContainer = (props) => {
  const defaultLimit = 50;
  const classes = useStyles();
  const { t } = useTranslation();
  const scrollRef = useReference();
  const {
    sort,
    order,
    params = {},
    getParam,
    handleRowClick,
    handleToggleModal,
    className,
    dense,
    hasCheckbox,
    hasTotal,
    title,
    tableTitle,
    customized = {},
    hasExcel = false,
    excelTotalRemoval = false,
    noneSearch = false,
    expandTable,
    makeSubParam,
    noScroll,
    wantRowData,
    pointer,
    childColumnSet = {},
    isModalHeight,
    useColumSet = false,
    toolTip = null,
    hasModal,
    location,
    dataReqPromise,
    limit,
    //getTableList,
    dataDetailReqPromise,
    addColumnList = new Map(), //테이블에 강제로 컬럼추가시 사용
    reGetData, //데이터처리후 새로고침에 사용
    noneFirstFetching = false, //초기 테이블 리스트 안불러올떄 사용
    callBack, // 콜백함수
    hasActController = {}, // 테이블 checkBox 버튼 컨트롤러
    headCallBack, // 테이블 헤드에서 사용되는 callBack함수
    reFetchHead,
  } = props;

  const { isFrame } = queryString.parse(location.search);
  const [getParams, setParams] = useState(params);
  const [getHeadCells, setHeadCells] = useState(new Map());
  const [getSelected, setSelected] = useState([]);
  const [getSelectedVal, setSelectedVal] = useState([]);
  const [getList, setList] = useState([]);
  const [getError, setError] = useState(false);
  const [getSort, setSort] = useState(sort);
  const [getOrder, setOrder] = useState(order);
  const [getMoreFetching, setMoreFetching] = useState(false);
  const [getTotalList, setTotalList] = useState(null);
  const [getScreenMode, setScreenMode] = useState('');
  const [getKeyword, setKeyword] = useState('');
  const [getLoading, setLoading] = useState(true);
  const [getReLoading, setReLoading] = useState(false);
  const [getChildrenCnt, setChildrenCnt] = useState(2);
  const [getPage, setPage] = useState(1);
  const [getSnackbarData, setSnackbarData] = useState({
    open: false,
    state: '',
    message: '',
  });
  const [loadingExcel, setLoadingExcel] = useState(false);

  const [noRequests, setNoRequests] = useState(false);
  //마운트 이후 디폴트 실행
  useEffect(() => {
    if (!reFetchHead) {
      const { uri } = params;
      firstFetching = true;
      pathName = window.location.pathname;
      fetchHeader(tableHeaders, addColumnList, {
        table: typeof params.table !== 'undefined' ? params.table : null,
        uri: typeof uri !== 'undefined' ? conversionUri(uri) : pathName,
      }).then((headers) => setHeadCells(headers));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchList(); // eslint-disable-next-line
  }, [getPage]);

  useEffect(() => {
    if (
      order !== getOrder ||
      ('null' !== getKeyword &&
        'undefined' !== getKeyword &&
        firstFetching === false)
    ) {
      setLoading(true);
      setPage(1);
      fetchList(); // eslint-disable-next-line
    }

    if (getPage === 1 && !!scrollRef.current) {
      scrollRef.current.scrollTop(0);
    } // eslint-disable-next-line
  }, [getSort, getOrder, getKeyword]);

  useEffect(() => {
    if (
      JSON.stringify(qs.stringify(params)) !==
      JSON.stringify(qs.stringify(getParams))
    ) {
      setSelected([]);
      setPage(1);
      setLoading(true);
      setParams(params);
      fetchList();
    } // eslint-disable-next-line
  }, [params]);

  useEffect(() => {
    if (reGetData === true) {
      setSelected([]);
      fetchList();
    } // eslint-disable-next-line
  }, [reGetData]);

  const conversionUri = (paramUrl) => {
    let resultUri;
    pathName = window.location.pathname;
    if (
      paramUrl !== '' &&
      typeof paramUrl === 'string' &&
      typeof paramUrl !== 'undefined' &&
      typeof pathName !== 'undefined'
    ) {
      resultUri = paramUrl;
    } else {
      resultUri = pathName;
    }
    return resultUri;
  };

  /**
   * 리스트를 받아옴
   */
  const fetchList = () => {
    const { uri } = params;

    if (reFetchHead) {
      const { uri } = params;
      firstFetching = true;
      pathName = window.location.pathname;
      fetchHeader(tableHeaders, addColumnList, {
        table: typeof params.table !== 'undefined' ? params.table : null,
        uri: typeof uri !== 'undefined' ? conversionUri(uri) : pathName,
      }).then((headers) => setHeadCells(headers));
    }

    if (noneFirstFetching === true) {
      callBack();
      setLoading(false);
      return;
    }
    if (!getMoreFetching && getPage !== 1) {
      setMoreFetching(true);
    }

    if (hasTotal && getPage === 1) {
      let addParams = {};
      //키워드
      if (typeof getKeyword !== 'undefined' && getKeyword !== '') {
        addParams = {
          ...addParams,
          keyword: nullConversion(getKeyword),
        };
      }

      dataReqPromise({
        params: {
          ...paramConverter(params),
          ...addParams,
          total: 1,
          uri: conversionUri(uri),
        },
      })
        .then((response) => {
          //추가데이터가 있다면 콜백함수 실행
          const { data } = response.data;
          if (typeof data.subData !== 'undefined') {
            if (typeof callBack !== 'undefined') {
              callBack(data.subData);
            }
            setTotalList(data.list);
          } else {
            const { data } = response.data;
            setTotalList(data);
          }
          setLoading(false);
          setReLoading(false);
        })
        .catch((error) => {
          setMoreFetching(false);
          setError(true);
        });
    }

    if (
      typeof params.sort !== 'undefined' ||
      typeof params.order !== 'undefined'
    ) {
      if (getSort !== params.sort || getOrder !== params.order) {
        setOrder(params.order);
        setSort(params.sort);
      }
    }

    //기본적으로 사용하는 params 추가
    let addParams = {};
    //정렬컬럼
    if (getOrder !== params.order && typeof params.order === 'undefined') {
      addParams = {
        ...addParams,
        order: under2camel(getOrder),
      };
    } else {
      addParams = {
        ...addParams,
        order: under2camel(params.order),
      };
    }

    //정렬종류
    if (getOrder !== params.order && typeof params.order === 'undefined') {
      addParams = {
        ...addParams,
        sort: under2camel(getSort),
      };
    } else {
      addParams = {
        ...addParams,
        sort: under2camel(params.sort),
      };
    }

    //키워드
    if (typeof getKeyword !== 'undefined' && getKeyword !== '') {
      addParams = {
        ...addParams,
        keyword: nullConversion(getKeyword),
      };
    }
    dataReqPromise({
      params: {
        ...paramConverter(params),
        ...addParams,
        page: getPage,
        limit: noScroll
          ? ''
          : limit !== undefined
          ? limit
          : params.limit !== undefined
          ? params.limit
          : defaultLimit,
        uri: conversionUri(uri),
      },
    })
      .then((response) => {
        //추가데이터가 있다면
        const { data } = response.data;
        if (typeof data.subData !== 'undefined') {
          const orgList = !getList || getPage === 1 ? [] : getList;
          let newData = {};
          if (typeof callBack !== 'undefined') {
            newData = orgList.concat(data.list);
            callBack(data.subData);
          } else {
            newData = orgList.concat(data);
          }
          setList(newData);
          if (data.length === 0) {
            setNoRequests(true);
          }
        } else {
          const { data } = response.data;
          const orgList = !getList || getPage === 1 ? [] : getList;
          const newData = orgList.concat(data);
          setList(newData);
          if (data.length === 0) {
            setNoRequests(true);
          }
        }
        setError(false);
        setLoading(false);
        setReLoading(false);
        setMoreFetching(false);
        // if (!!getTableList) {
        //   getTableList(newData);
        // }
      })
      .catch((error) => {
        setPage(1);
        setList(null);
        setError(true);
        setSelected([]);
      })
      .finally(() => {
        setMoreFetching(false);
        setLoading(false);
        setReLoading(false);
        firstFetching = false;
      });
  };
  /**
   * 테이블 로우 클릭시 상세 정보 요청후 넣어주는 함수
   */
  const fetchDetailList = (appendIndex, detailParams) => {
    dataDetailReqPromise({
      params: {
        ...paramConverter(params),
        ...detailParams,
      },
    })
      .then((response) => {
        const { data } = response.data;
        const newData = [].concat(getList);
        const curRow = newData[appendIndex];
        curRow['isOpen'] = true;

        for (let i = 0; i < data.length; i++) {
          const cur = data[i];
          cur['isChild'] = true;
        }
        newData.splice(appendIndex + 1, 0, ...data);

        setError(false);
        setList(newData);
        setChildrenCnt(data.length);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * 엑셀 다운로드
   */
  const handleExcelDonload = () => {
    let newParams = {
      params: {
        ...paramConverter(params),
        excel: 1,
        order: getOrder,
        sort: getSort,
        // 현재 서버에서 처리하고 있지 않음
        page: getPage,
        limit: limit,
      },
      responseType: 'blob',
    };
    if (excelTotalRemoval) {
      newParams = {
        ...newParams,
        params: {
          ...newParams.params,
          noneTotal: 1,
        },
      };
    }
    setLoadingExcel(true);
    dataReqPromise(newParams)
      .then((response) => {
        fileDownload(response);
      })
      .catch((error) => {
        alert(error);
      })
      .finally(() => {
        setLoadingExcel(false);
      });
  };

  /**
   * 화면 모드 변경
   */
  const handleScreenMode = () => {
    fullTableHeight = window.innerHeight - 100;
    if (getScreenMode === '') {
      setScreenMode('full');
    } else {
      setScreenMode('');
    }
  };

  /**
   * odering
   * @param {} event
   * @param {string} orderKey ordering 할 header id
   */
  const handleRequestSort = (event, orderKey) => {
    const isDesc = getOrder === orderKey && getSort === 'desc';
    const converSort = isDesc ? 'asc' : 'desc';

    setPage(1);
    setSort(converSort);
    setOrder(orderKey);
    setSelected([]);

    if (typeof sort === 'undefined' && typeof order === 'undefined') {
      getParam({
        ...params,
        sort: converSort,
        order: orderKey,
      });
    }
  };
  /**
   * 스크롤이벤트 (페이징처리시 사용)
   * @param event
   */
  const handleTableScroll = (event) => {
    const { scrollHeight, scrollTop, clientHeight } = event.currentTarget;
    if (
      scrollTop !== 0 &&
      //   scrollHeight - scrollTop < clientHeight * 1.2 &&
      scrollHeight === scrollTop + clientHeight &&
      getMoreFetching === false
    ) {
      if (!noRequests) {
        // 다음 페이지 정보 받아옴
        let newPage = getPage + 1;
        setPage(newPage);
        setMoreFetching(true);
      }
    }
  };

  /**
   * 테이블 row 클릭
   * @param {String} event
   * @param {String} key
   */
  const handleClick = useCallback(
    (e) => {
      let key = Number(e.currentTarget.dataset.key);

      if (wantRowData) {
        const clickRowData = getList[key];
        handleRowClick(clickRowData);
      }

      if (hasModal) {
        const clickRowData = getList[key];
        handleToggleModal(true, clickRowData.STATS_HH);
      }

      if (expandTable) {
        // 세부정보 받아오기
        const curRow = getList[key];
        const { isOpen, isChild } = curRow;
        //console.log('curRow', curRow);
        if (isChild) {
          return;
        }

        // 세부정보 받아오지 않은 경우 (API를 통해 서브데이터를 받아옴)
        if (dataDetailReqPromise && typeof isOpen === 'undefined') {
          fetchDetailList(key, makeSubParam(curRow));
        } else {
          const newList = [].concat(getList);
          const startIndex = key + 1;
          const display = !curRow['isOpen'];
          //console.log('isOpen)', isOpen);

          curRow['isOpen'] = display;

          for (let i = startIndex; i < startIndex + getChildrenCnt; i++) {
            const child = newList[i];
            child['display'] = display;
            child['isOpen'] = display;
            //console.log('child', child);
          }
          setList(newList);
        }
      } else if (
        !expandTable &&
        wantRowData === undefined &&
        !hasModal &&
        typeof hasCheckbox !== 'undefined'
      ) {
        const selectedIndex = getSelected.indexOf(key);

        let newSelected = [];
        let newSelectedVal = [];

        if (selectedIndex === -1) {
          newSelected = newSelected.concat(getSelected, key);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(getSelected.slice(1));
        } else if (selectedIndex === getSelected.length - 1) {
          newSelected = newSelected.concat(getSelected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            getSelected.slice(0, selectedIndex),
            getSelected.slice(selectedIndex + 1)
          );
        }
        for (let i = 0; i < newSelected.length; i++) {
          newSelectedVal.push(getList[newSelected[i]]);
        }
        setSelected(newSelected);
        setSelectedVal(newSelectedVal);
      }
    }, // eslint-disable-next-line
    [
      wantRowData,
      handleRowClick,
      getList,
      hasModal,
      handleToggleModal,
      expandTable,
      dataDetailReqPromise,
      makeSubParam,
      getSelected,
    ]
  );

  /**
   * checkBox 전체선택 컨트롤 함수
   * @param event
   */
  const handleCheckboxAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = [];
      let newSelectedVal = [];
      for (let i = 0; i < getList.length; i++) {
        newSelecteds.push(i);
        newSelectedVal.push(getList[i]);
      }
      setSelected(newSelecteds);
      setSelectedVal(newSelectedVal);
    } else {
      setSelected([]);
      setSelectedVal([]);
    }
  };

  /**
   * 컬럼 설정 저장
   */
  const handleSaveColumnSet = (customColumn) => {
    const heads = [];
    for (let column of customColumn.values()) {
      const { id, displayFlag } = column;
      if (id === 'SEQ') {
        continue;
      }

      if (displayFlag) {
        heads.push(id);
      }
    }

    setCustom({ values: heads.join(','), type: 'table.head' })
      .then((response) => {})
      .catch((error) => console.log(error));

    setHeadCells(customColumn);
  };

  const handleSearch = (keyword) => {
    setKeyword(keyword);
  };

  /**
   * 좌우 스크롤안내 open
   */
  const handleInTableInfo = () => {
    const contentWidth = document.getElementById('secVerScroll').offsetWidth;
    const tableWidth = document.getElementById('tableContents').offsetWidth;
    if (hoverCount === 0 && contentWidth < tableWidth) {
      hoverCount++;
      let newSnackbarData = {
        open: true,
        state: 'info',
        message: '좌우 스크롤 기능 안내 : Shift + 마우스 휠',
      };
      setSnackbarData(newSnackbarData);
    }
  };

  /**
   * 좌우 스크롤안내 Close
   */
  const handleInTableInfoClose = () => {
    let newSnackbarData = {
      open: false,
      state: 'info',
      message: '',
    };
    setSnackbarData(newSnackbarData);
  };

  return (
    <>
      <div
        className={clsx(
          getScreenMode === 'full' ? classes.fullscreen : '',
          className
        )}
      >
        <EnhancedTableWrap
          toolTip={toolTip}
          className={classes.tableWrap}
          columnSetButton={
            useColumSet ? (
              <DivisionWrap>
                <SetUpList
                  list={getHeadCells}
                  customized={customized}
                  handleSaveCustomSet={handleSaveColumnSet}
                  title={t('컬럼설정')}
                  popoverTitle={t('나만의 기본 컬럼을 설정해보세요.')}
                  popoverNotice={t('설정 이후 선택한 컬럼만 노출됩니다.')}
                  saveButtonTitle={t('내 컬럼으로 설정')}
                />
              </DivisionWrap>
            ) : undefined
          }
          selectedCnt={getSelected.length}
          selectedVal={getSelectedVal}
          title={title}
          hasExcel={hasExcel}
          noneSearch={noneSearch}
          handleExcelDonload={handleExcelDonload}
          handleScreenMode={handleScreenMode}
          screenMode={getScreenMode}
          headcells={getHeadCells}
          handleSearch={handleSearch}
          isFrame={isFrame}
          hasActController={hasActController}
          headCallBack={headCallBack}
          loadingExcel={loadingExcel}
        >
          <Scrollbars
            className={clsx(
              { isModalHeight },
              classes.tableCustomScrollBar
              //   getScreenMode === 'full' ? classes.fullscreenBody : ''
            )}
            onScroll={!noScroll ? handleTableScroll : undefined}
            ref={scrollRef}
          >
            <div
              id="tableContents"
              className={clsx(classes.tableContentsWrap)}
              style={{ maxHeight: getScreenMode === 'full' && fullTableHeight }}
            >
              <div className={classes.stickyColumn}>
                {typeof tableTitle !== 'undefined' && <h6>{tableTitle}</h6>}
                <Table
                  aria-labelledby="tableTitle"
                  size={dense ? 'small' : 'medium'}
                  classes={{
                    root: classes.tableSection,
                  }}
                >
                  <EnhancedTableHead
                    numSelected={getSelected.length}
                    order={getOrder}
                    sort={getSort}
                    onCheckboxAllClick={handleCheckboxAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={getList === null ? 0 : getList.length}
                    headCells={getHeadCells}
                    hasCheckbox={hasCheckbox}
                    customized={customized}
                  />

                  <EnhancedTableBody
                    headCells={getHeadCells}
                    list={getList}
                    totalList={getTotalList}
                    selected={getSelected}
                    hasCheckbox={hasCheckbox}
                    hasTotal={hasTotal}
                    wantRowData={wantRowData}
                    pointer={pointer}
                    handleClick={
                      (typeof hasCheckbox !== 'undefined' ||
                        expandTable ||
                        wantRowData ||
                        hasModal) &&
                      handleClick
                    }
                    error={getError}
                    loading={getLoading}
                    reLoading={getReLoading}
                    page={getPage}
                    moreFetching={getMoreFetching}
                    customized={customized}
                    expandTable={expandTable}
                    childColumnSet={childColumnSet}
                    hasModal={hasModal}
                    onMouseEnter={hoverCount === 2 ? null : handleInTableInfo}
                    firstFetching={firstFetching}
                    getScreenMode={getScreenMode}
                  />
                </Table>
              </div>
            </div>
          </Scrollbars>
          {/* </div> */}
          <div
            className={clsx(classes.loadingBarWrap, {
              loading: getPage !== 1 && getMoreFetching,
            })}
          >
            <div className={clsx(classes.loadingBar)}>
              {/* 무한스크롤 로딩 */}
              <LinearProgress className={classes.progress} />
            </div>
          </div>
        </EnhancedTableWrap>
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={getSnackbarData.open}
        autoHideDuration={10000}
        onClose={handleInTableInfoClose}
        style={{ zIndex: 99999 }}
      >
        <SnackbarContentWrapper
          message={getSnackbarData.message}
          variant={getSnackbarData.state}
          classes={{
            message: classes.messageSize,
          }}
        />
      </Snackbar>
    </>
  );
};

EnhancedTableContainer.propTypes = {
  // example props for the demo
  callBack: PropTypes.func, // 콜백함수
  reGetData: PropTypes.bool, // 새로고침여부
  hasActController: PropTypes.object, //  테이블 checkBox 버튼 컨트롤러
  headCallBack: PropTypes.func, //  테이블 헤드에서 사용되는 callBack함수
};

export default React.memo(withRouter(EnhancedTableContainer));
